/**
 * @file InputNumber 数字输入框
 * @author zhongziyan
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import React from 'react';
import UpOutlined from 'acud-icon/lib/icons/OutlinedUp';
import DownOutlined from 'acud-icon/lib/icons/OutlinedDown';
import OutlinedMinus from 'acud-icon/lib/icons/OutlinedMinus';
import OutlinedPlus from 'acud-icon/lib/icons/OutlinedPlus';
import { ConfigContext } from '../config-provider';
import SizeContext from '../config-provider/SizeContext';
import Popover from '../popover';
import RcInputNumber from './src';
const InputNumber = React.forwardRef((props, ref) => {
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const size = React.useContext(SizeContext);
    const { className, size: customizeSize, prefixCls: customizePrefixCls, bordered = true, readOnly, warning, warningPopover, warningText, symmetryMode = false, style } = props, others = __rest(props, ["className", "size", "prefixCls", "bordered", "readOnly", "warning", "warningPopover", "warningText", "symmetryMode", "style"]);
    const prefixCls = getPrefixCls('input-number', customizePrefixCls);
    const UpIcon = symmetryMode ? OutlinedPlus : UpOutlined;
    const DownIcon = symmetryMode ? OutlinedMinus : DownOutlined;
    const upIcon = <UpIcon className={`${prefixCls}-handler-up-inner`}/>;
    const downIcon = <DownIcon className={`${prefixCls}-handler-down-inner`}/>;
    const mergeSize = customizeSize || size || 'middle';
    const inputNumberClass = classNames({
        [`${prefixCls}-lg`]: mergeSize === 'large',
        [`${prefixCls}-sm`]: mergeSize === 'small',
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-readonly`]: readOnly,
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-warning`]: warning || warningPopover,
        [`${prefixCls}-symmetry`]: symmetryMode
    }, className);
    const inputWrapperClass = classNames({
        [`${prefixCls}-lg`]: mergeSize === 'large',
        [`${prefixCls}-sm`]: mergeSize === 'small',
        [`${prefixCls}-md`]: mergeSize === 'middle'
    }, `${prefixCls}-wrapper`);
    return (<Popover content={<span className={`${prefixCls}-warning-popover-text`}>
                    {warningText}
                </span>} placement="bottom" visible={warningPopover && !!warningText} trigger="none">
            <div className={inputWrapperClass} style={style}>
                <RcInputNumber ref={ref} className={inputNumberClass} upHandler={upIcon} downHandler={downIcon} prefixCls={prefixCls} readOnly={readOnly} style={style} symmetryMode={symmetryMode} {...others}/>
                {warning && warningText && (<div className={`${prefixCls}-warning-text`}>
                        {warningText}
                    </div>)}
            </div>
        </Popover>);
});
export default InputNumber;
